// import React, { useEffect, useState } from 'react';
// import { useTable } from 'react-table';
// import SubscriptionPopup from './SubscriptionPopup';
// import Popup from 'reactjs-popup';
// import 'reactjs-popup/dist/index.css';
// import { FaBriefcase, FaCog, FaLock, FaUser, FaWhatsapp } from 'react-icons/fa';


// const AccountDetails = () => {
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     whatsappBusinessId: '',
//     oldPassword: '',
//     newPassword: '',
//     confirmPassword: '',
//   });
//   const [image, setImage] = useState(null);

//   useEffect(() => {
//     // Simulating getting user data from sessionStorage (or another state management system)
//     const storedUser = JSON.parse(sessionStorage.getItem('user'));
//     if (storedUser) {
//       setUser(storedUser);
//       setFormData({
//         name: storedUser.name || '',
//         email: storedUser.email || '',
//         phone: storedUser.phone || '',
//         whatsappBusinessId: storedUser.whatsappBusinessId || '',
//         oldPassword: '',
//         newPassword: '',
//         confirmPassword: '',
//       });
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSaveChanges = async (e) => {
//     e.preventDefault();

//     if (formData.newPassword !== formData.confirmNewPassword) {
//       alert('New passwords do not match.');
//       return;
//     }

//     const form = new FormData();
//     form.append('userId', user.id);
//     form.append('name', formData.name);
//     form.append('email', formData.email);
//     form.append('phone', formData.phone);
//     form.append('whatsappBusinessId', formData.whatsappBusinessId);
//     form.append('oldPassword', formData.oldPassword);
//     form.append('newPassword', formData.newPassword);
//     if (image) form.append('image', image);

//     try {
//       const response = await fetch('https://botapi.emedha.in/auth/api/update-profile', {
//         method: 'PUT',
//         body: form,
//       });

//       const data = await response.json();
//       if (!response.ok) {
//         alert(data.error || 'Error updating profile');
//       } else {
//         alert(data.message);
//         // Optionally refresh sessionStorage or user state here
//       }
//     } catch (error) {
//       console.error('Error during profile update:', error);
//       alert('Error during profile update. Please try again later.');
//     }
//   };



//   const [showPopup, setShowPopup] = useState(false);
//   const [selectedSection, setSelectedSection] = useState('account');
//   const handleSectionChange = (section) => {
//     setSelectedSection(section);
//   };



//   const columns = React.useMemo(
//     () => [
//       {
//         Header: 'DISPLAY NAME',
//         accessor: 'displayName',
//       },
//       {
//         Header: 'PHONE NUMBER',
//         accessor: 'phoneNumber',
//       },
//       {
//         Header: 'PHONE NUMBER ID',
//         accessor: 'phoneNumberId',
//       },
//       {
//         Header: 'CONNECTION',
//         accessor: 'connection',
//       },
//       {
//         Header: 'STATUS',
//         accessor: 'status',
//         Cell: ({ value }) => (
//           <span className={`px-2 py-1 rounded-md ${value === 'CONNECTED' ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'}`}>
//             {value}
//           </span>
//         ),
//       },
//       {
//         Header: 'SUBSCRIPTION',
//         accessor: 'subscription',
//       },
//     ],
//     []
//   );

//   const data = React.useMemo(
//     () => [
//       {
//         displayName: 'eMedha Chatbot Services Test',
//         phoneNumber: '+91 83297 69248',
//         phoneNumberId: '110********',
//         connection: 'Direct',
//         status: 'CONNECTED',
//         subscription: 'Startup (Monthly)',
//       },
//     ],
//     []
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     rows,
//     prepareRow,
//   } = useTable({
//     columns,
//     data,
//   });

//   return (

//     <div style={{ maxWidth: '1024px', margin: '0 auto', padding: '1rem', }}>
//       <div style={{ backgroundColor: 'white', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', borderRadius: '0.375rem', padding: '1.5rem', }}>
//         <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
//           <button
//             style={selectedSection === 'account' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
//             onClick={() => handleSectionChange('account')}>
//             <FaUser style={{ marginRight: '8px' }} /> My Account
//           </button>
//           <button
//             style={selectedSection === 'whatsapp' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#f1f1f1', color: '#4A4A4A', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
//             onClick={() => handleSectionChange('whatsapp')}>
//             <FaWhatsapp style={{ marginRight: '8px' }} /> WhatsApp Numbers
//           </button>
//           {/* <button
//             style={selectedSection === 'subscriptions' ? { backgroundColor: '#14B8A6', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', } : { backgroundColor: '#f1f1f1', color: '#4A4A4A', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }}
//             onClick={() => handleSectionChange('subscriptions')}>
//             <FaCog style={{ marginRight: '8px' }} /> My Subscriptions
//           </button> */}
//         </div>

//         {selectedSection === 'account' && (
//           <div style={{ marginBottom: '1.5rem' }}>
//             <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
//               <FaUser style={{ marginRight: '8px' }} /> Account Details
//             </h2>
//             <p style={{ color: '#4A4A4A', marginBottom: '1rem' }}>
//               Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
//               To edit how your WhatsApp profile looks to your contacts, you can edit that from
//               <a href="#" style={{ color: '#14B8A6' }}> Settings</a> page.
//             </p>
//             <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
//               <div style={{ marginBottom: '1.5rem' }}>
//                 <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
//                   <FaUser style={{ marginRight: '8px' }} /> Account Information
//                 </h2>
//                 <p style={{ color: '#4A4A4A', marginBottom: '1rem' }}>
//                   Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
//                 </p>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaUser style={{ marginRight: '8px' }} />NAME *
//                     </label>
//                     <input type="text" name="name" value={formData.name} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>

//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>Profile Image</label>
//                     <input type="file" name="image" accept="image/*" onChange={(e) => setImage(e.target.files[0])} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem', }} />
//                   </div>

//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaUser style={{ marginRight: '8px' }} /> EMAIL ADDRESS *
//                     </label>
//                     <input type="email" name="email" value={formData.email} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaUser style={{ marginRight: '8px' }} /> Mobile *
//                     </label>
//                     <input type="email" name="phone" value={formData.phone} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaUser style={{ marginRight: '8px' }} /> TIMEZONE *
//                     </label>
//                     <select name="timezone" value={formData.timezone} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} >
//                       <option>UTC+5:30</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaUser style={{ marginRight: '8px' }} />  WhatsApp Business ID *
//                     </label>
//                     <input type="text" name="whatsappBusinessId" value={formData.whatsappBusinessId} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                 </div>
//               </div>

//               <div style={{ marginBottom: '1.5rem' }}>
//                 <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
//                   <FaBriefcase style={{ marginRight: '8px' }} /> Billing Details
//                 </h2>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaBriefcase style={{ marginRight: '8px' }} /> FIRST NAME *
//                     </label>
//                     <input type="text" name="billingFirstName" value={formData.billingFirstName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaBriefcase style={{ marginRight: '8px' }} /> LAST NAME *
//                     </label>
//                     <input type="text" name="billingLastName" value={formData.billingLastName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaBriefcase style={{ marginRight: '8px' }} /> COMPANY NAME (OPTIONAL)
//                     </label>
//                     <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaBriefcase style={{ marginRight: '8px' }} /> COUNTRY / REGION
//                     </label>
//                     <input type="text" name="country" value={formData.country} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                 </div>
//               </div>

//               {/* Password Section */}
//               <div>
//                 <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
//                   <FaLock style={{ marginRight: '8px' }} /> Password
//                 </h2>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1rem', '@media (min-width: 768px)': { gridTemplateColumns: 'repeat(2, 1fr)' } }}>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaLock style={{ marginRight: '8px' }} /> CURRENT PASSWORD *
//                     </label>
//                     <input type="password" name="oldPassword" value={formData.oldPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaLock style={{ marginRight: '8px' }} /> NEW PASSWORD *
//                     </label>
//                     <input type="password" name="newPassword" value={formData.newPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                   <div>
//                     <label style={{ color: '#4A4A4A' }}>
//                       <FaLock style={{ marginRight: '8px' }} /> CONFIRM NEW PASSWORD *
//                     </label>
//                     <input type="password" name="confirmNewPassword" value={formData.confirmNewPassword} onChange={handleChange} style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: '0.375rem', padding: '0.5rem 0.75rem', marginTop: '0.25rem' }} />
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <button style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', }} onClick={handleSaveChanges}>
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}




//         <>
//           {selectedSection === 'whatsapp' && (
//             <div>
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">WhatsApp Phone Numbers</h2>
//               </div>
//               <p className="text-gray-600 mb-4">
//                 On this page you'll find all the WhatsApp phone numbers that are connected with eMedha Chatbot Services and the WhatsApp Cloud APIs.
//               </p>
//               <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
//                 <div className="d-flex flex-row justify-content-between items-center border-b pb-2 mb-4">
//                   <div>
//                     <h3 className="text-lg font-semibold">eMedha Chatbot Services</h3>
//                     <p className="text-gray-500">
//                       WABA ID: 109<span className="bg-gray-200 rounded px-2 py-1 ml-2">********</span>
//                     </p>
//                   </div>
//                   <button className="btn btn-primary" style={{ height: 40 }}>WhatsApp Manager</button>
//                 </div>

//                 <table {...getTableProps()} className="w-full text-left">
//                   <thead>
//                     {headerGroups.map(headerGroup => (
//                       <tr {...headerGroup.getHeaderGroupProps()} className="text-gray-600">
//                         {headerGroup.headers.map(column => (
//                           <th {...column.getHeaderProps()} className="py-2">
//                             {column.render('Header')}
//                           </th>
//                         ))}
//                       </tr>
//                     ))}
//                   </thead>
//                   <tbody {...getTableBodyProps()}>
//                     {rows.map(row => {
//                       prepareRow(row);
//                       return (
//                         <tr {...row.getRowProps()} className="bg-white border-b">
//                           {row.cells.map(cell => {
//                             return (
//                               <td {...cell.getCellProps()} className="py-2">
//                                 {cell.render('Cell')}
//                               </td>
//                             );
//                           })}
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </>

//         {selectedSection === 'subscriptions' && (
//           <div>
//             <div className="d-flex flex-row justify-content-between items-center border-b pb-2 mb-4">
//               <div>
//                 <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', }}>My Subscriptions</h2>
//               </div>
//               <button className="btn btn-primary" onClick={() => setShowPopup(true)}>Buy Subscription</button>
//             </div>
//             <table className="w-full text-left">
//               <thead>
//                 <tr className="text-gray-600">
//                   <th className="py-2">ID</th>
//                   <th className="py-2">STATUS</th>
//                   <th className="py-2">SUBSCRIPTION</th>
//                   <th className="py-2">NEXT PAYMENT</th>
//                   <th className="py-2">TOTAL</th>
//                   <th className="py-2">ASSOCIATED WHATSAPP NUMBER</th>
//                   <th className="py-2"></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr className="border-t">
//                   <td className="py-2 text-teal-600">#235171</td>
//                   <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
//                   <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2">₹2,358.82</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
//                 </tr>
//                 <tr className="border-t">
//                   <td className="py-2 text-teal-600">#232409</td>
//                   <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
//                   <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2">₹2,358.82</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
//                 </tr>
//                 <tr className="border-t">
//                   <td className="py-2 text-teal-600">#158351</td>
//                   <td className="py-2"><span className="bg-gray-300 text-gray-600 px-2 py-1 rounded">CANCELLED</span></td>
//                   <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2">₹23.59</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
//                 </tr>
//                 <tr className="border-t">
//                   <td className="py-2 text-teal-600">#56217</td>
//                   <td className="py-2"><span className="bg-yellow-400 text-white px-2 py-1 rounded">PENDING CANCELLATION</span></td>
//                   <td className="py-2">eMedha Chatbot Services - Startup (Monthly)</td>
//                   <td className="py-2">-</td>
//                   <td className="py-2">₹23.59</td>
//                   <td className="py-2 text-teal-600">eMedha Chatbot Services Test (+91 83297 69248)</td>
//                   <td className="py-2"><button className="text-teal-600 border border-teal-600 px-4 py-1 rounded">View</button></td>
//                 </tr>
//               </tbody>
//             </table>
//             <Popup
//               open={showPopup}
//               closeOnDocumentClick
//               onClose={() => setShowPopup(false)}
//               modal
//               nested
//             >
//               {(close) => (
//                 <div className="relative">
//                   <SubscriptionPopup onClose={close} />
//                 </div>
//               )}
//             </Popup>
//           </div>
//         )}
//       </div>
//     </div>

//   );
// };

// export default AccountDetails;

// import React, { useState, useRef } from "react";
// import {
//   User, Phone, Save, Upload, Building2,
//   Lock, Eye, EyeOff, CheckCircle, Wifi, ChevronRight, ArrowLeft,
// } from "lucide-react";

// // ─── Theme Configuration ─────────────────────────────────────────────────────
// const theme = {
//   primary: "#2563eb",
//   primaryForeground: "#ffffff",
//   primaryLight: "rgba(37, 99, 235, 0.1)",
//   primaryFocus: "rgba(37, 99, 235, 0.3)",
//   background: "#f9fafb",
//   card: "#ffffff",
//   border: "#e5e7eb",
//   muted: "#f3f4f6",
//   mutedForeground: "#6b7280",
//   foreground: "#111827",
//   inputBackground: "#ffffff",
//   destructive: "#ef4444",
//   blueBg: "#eff6ff",
//   blueBorder: "#bfdbfe",
//   blueText: "#1d4ed8",
//   emeraldBg: "#ecfdf5",
//   emeraldBorder: "#a7f3d0",
//   emeraldText: "#047857",
//   emeraldDot: "#10b981",
// };

// const baseFont = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

// // ─── Shared field ────────────────────────────────────────────────────────────

// function Field({ label, required, type = "text", placeholder, defaultValue, hint, children }) {
//   const [isFocused, setIsFocused] = useState(false);

//   const inputStyle = {
//     width: "100%",
//     padding: "10px 12px",
//     borderRadius: "8px",
//     border: `1px solid ${isFocused ? theme.primary : theme.border}`,
//     backgroundColor: theme.inputBackground,
//     fontSize: "14px",
//     color: theme.foreground,
//     outline: "none",
//     boxShadow: isFocused ? `0 0 0 3px ${theme.primaryFocus}` : "none",
//     transition: "all 0.2s ease",
//     boxSizing: "border-box",
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//       <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: theme.foreground, textTransform: "uppercase", tracking: "0.05em", fontFamily: baseFont }}>
//         {label}
//         {required && <span style={{ color: theme.destructive, marginLeft: "2px" }}>*</span>}
//       </label>
//       {children ? (
//         React.cloneElement(children, {
//           onFocus: () => setIsFocused(true),
//           onBlur: () => setIsFocused(false),
//           style: { ...inputStyle, ...children.props.style }
//         })
//       ) : (
//         <input
//           type={type}
//           placeholder={placeholder}
//           defaultValue={defaultValue}
//           onFocus={() => setIsFocused(true)}
//           onBlur={() => setIsFocused(false)}
//           style={inputStyle}
//         />
//       )}
//       {hint && <p style={{ margin: 0, fontSize: "11px", color: theme.mutedForeground }}>{hint}</p>}
//     </div>
//   );
// }

// function SectionCard({ title, icon, children }) {
//   return (
//     <div style={{ backgroundColor: theme.card, borderRadius: "12px", border: `1px solid ${theme.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden", marginBottom: "20px" }}>
//       <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, backgroundColor: "rgba(243, 244, 246, 0.3)" }}>
//         <span style={{ color: theme.primary, display: "flex", alignItems: "center" }}>{icon}</span>
//         <h3 style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: theme.foreground, fontFamily: baseFont }}>{title}</h3>
//       </div>
//       <div style={{ padding: "20px" }}>{children}</div>
//     </div>
//   );
// }

// // ─── Tab: My Account ─────────────────────────────────────────────────────────

// function AccountTab() {
//   const [showCurrent, setShowCurrent] = useState(false);
//   const [showNew, setShowNew] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [avatarSrc, setAvatarSrc] = useState(null);
//   const fileRef = useRef(null);

//   const handleFile = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (ev) => setAvatarSrc(ev.target?.result);
//     reader.readAsDataURL(file);
//   };

//   const PasswordField = ({ label, show, toggle }) => {
//     const [isFocused, setIsFocused] = useState(false);
//     return (
//       <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//         <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: theme.foreground, textTransform: "uppercase", fontFamily: baseFont }}>
//           {label}<span style={{ color: theme.destructive, marginLeft: "2px" }}>*</span>
//         </label>
//         <div style={{ position: "relative", width: "100%" }}>
//           <input
//             type={show ? "text" : "password"}
//             placeholder="••••••••••"
//             onFocus={() => setIsFocused(true)}
//             onBlur={() => setIsFocused(false)}
//             style={{
//               width: "100%",
//               padding: "10px 40px 10px 12px",
//               borderRadius: "8px",
//               border: `1px solid ${isFocused ? theme.primary : theme.border}`,
//               backgroundColor: theme.inputBackground,
//               fontSize: "14px",
//               color: theme.foreground,
//               outline: "none",
//               boxShadow: isFocused ? `0 0 0 3px ${theme.primaryFocus}` : "none",
//               transition: "all 0.2s ease",
//               boxSizing: "border-box",
//             }}
//           />
//           <button
//             type="button"
//             onClick={toggle}
//             style={{
//               position: "absolute",
//               right: "12px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               color: theme.mutedForeground,
//               display: "flex",
//               alignItems: "center",
//               padding: 0,
//             }}
//           >
//             {show ? <EyeOff size={14} /> : <Eye size={14} />}
//           </button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
//       {/* Info banner */}
//       <div style={{ backgroundColor: theme.blueBg, border: `1px solid ${theme.blueBorder}`, borderRadius: "12px", padding: "12px 16px", display: "flex", alignItems: "start", gap: "12px" }}>
//         <CheckCircle size={15} style={{ color: theme.blueText, marginTop: "2px", flexShrink: 0 }} />
//         <p style={{ margin: 0, fontSize: "12px", color: theme.blueText, lineHeight: "1.5", fontFamily: baseFont }}>
//           Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
//           To edit how your WhatsApp profile looks to your contacts, you can edit that from <span style={{ fontWeight: "600" }}>Settings page</span>.
//         </p>
//       </div>

//       {/* Account Information */}
//       <SectionCard title="Account Information" icon={<User size={15} />}>
//         <p style={{ margin: "0 0 16px 0", fontSize: "12px", color: theme.mutedForeground }}>
//           Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
//         </p>
        
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//           {/* Avatar row */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//             <p style={{ margin: 0, fontSize: "12px", fontWeight: "600", color: theme.foreground, textTransform: "uppercase", fontFamily: baseFont }}>Profile Image</p>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//               <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: theme.primaryLight, display: "flex", alignItems: "center", justifyValue: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0, border: `2px solid ${theme.border}` }}>
//                 {avatarSrc ? (
//                   <img src={avatarSrc} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                 ) : (
//                   <User size={22} style={{ color: theme.primary }} />
//                 )}
//               </div>
//               <div>
//                 <button
//                   onClick={() => fileRef.current?.click()}
//                   style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "6px 12px", borderRadius: "8px", border: `1px solid ${theme.border}`, backgroundColor: "#ffffff", fontSize: "12px", fontWeight: "500", color: theme.foreground, cursor: "pointer", fontFamily: baseFont }}
//                 >
//                   <Upload size={12} /> Choose File
//                 </button>
//                 <p style={{ margin: "4px 0 0 0", fontSize: "11px", color: theme.mutedForeground }}>{avatarSrc ? "File selected" : "No file chosen"}</p>
//               </div>
//               <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
//             </div>
//           </div>

//           {/* Grid Layout fields manually wrapped */}
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
//             <Field label="Name" required placeholder="Your name" />
//             <Field label="Email Address" required type="email" defaultValue="emedhatechnologies@gmail.com" />
//             <Field label="Mobile" required defaultValue="918919171985" />
//             <Field label="Timezone" required>
//               <select style={{ boxSizing: "border-box" }}>
//                 <option>UTC+5:30 — India Standard Time</option>
//                 <option>UTC+0:00 — Greenwich Mean Time</option>
//                 <option>UTC-5:00 — Eastern Standard Time</option>
//                 <option>UTC+8:00 — China Standard Time</option>
//               </select>
//             </Field>
//             <Field label="WhatsApp Business ID" required placeholder="Enter WABA ID" />
//           </div>
//         </div>
//       </SectionCard>

//       {/* Billing Details */}
//       <SectionCard title="Billing Details" icon={<Building2 size={15} />}>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
//           <Field label="First Name" required placeholder="First name" />
//           <Field label="Last Name" required placeholder="Last name" />
//           <Field label="Company Name (Optional)" placeholder="Your company" />
//           <Field label="Country / Region">
//             <select style={{ boxSizing: "border-box" }}>
//               <option>India</option>
//               <option>United States</option>
//               <option>United Kingdom</option>
//               <option>Singapore</option>
//               <option>UAE</option>
//             </select>
//           </Field>
//         </div>
//       </SectionCard>

//       {/* Password */}
//       <SectionCard title="Password" icon={<Lock size={15} />}>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
//           <PasswordField label="Current Password" show={showCurrent} toggle={() => setShowCurrent((v) => !v)} />
//           <PasswordField label="New Password" show={showNew} toggle={() => setShowNew((v) => !v)} />
//           <PasswordField label="Confirm New Password" show={showConfirm} toggle={() => setShowConfirm((v) => !v)} />
//         </div>
//       </SectionCard>

//       {/* Save Button */}
//       <div style={{ display: "flex", justifyContent: "flex-end" }}>
//         <button style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "10px 20px", borderRadius: "8px", backgroundColor: theme.primary, color: theme.primaryForeground, border: "none", fontSize: "14px", fontWeight: "600", cursor: "pointer", boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)", fontFamily: baseFont }}>
//           <Save size={14} /> Save Changes
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Tab: WhatsApp Numbers ───────────────────────────────────────────────────

// function WhatsAppTab() {
//   const numbers = [
//     {
//       displayName: "eMedha Chatbot Services Test",
//       phone: "+91 83297 69248",
//       phoneId: "110*******",
//       connection: "Direct",
//       status: "CONNECTED",
//       subscription: "Startup (Monthly)",
//     },
//   ];

//   const cellStyle = { padding: "16px 20px", fontSize: "13px", color: theme.foreground, borderBottom: `1px solid ${theme.border}`, textAlign: "left" };
//   const headerStyle = { padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: theme.mutedForeground, textTransform: "uppercase", backgroundColor: "rgba(243, 244, 246, 0.4)", borderBottom: `1px solid ${theme.border}`, textAlign: "left", fontFamily: baseFont };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
//       {/* Info banner */}
//       <div style={{ backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: "12px", padding: "12px 16px", display: "flex", alignItems: "start", gap: "12px" }}>
//         <Phone size={15} style={{ color: theme.primary, marginTop: "2px", flexShrink: 0 }} />
//         <p style={{ margin: 0, fontSize: "12px", color: theme.foreground, lineHeight: "1.5", fontFamily: baseFont }}>
//           On this page you'll find all the WhatsApp phone numbers that are connected with{" "}
//           <span style={{ fontWeight: "600" }}>eMedha Chatbot Services</span> and the WhatsApp Cloud APIs.
//         </p>
//       </div>

//       {/* WABA info card */}
//       <div style={{ backgroundColor: theme.card, borderRadius: "12px", border: `1px solid ${theme.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", padding: "20px" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//           <div style={{ width: "36px", height: "36px", borderRadius: "10px", backgroundColor: theme.primary, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//             <span style={{ color: "#ffffff", fontSize: "12px", fontWeight: "700" }}>eM</span>
//           </div>
//           <div>
//             <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: theme.foreground, fontFamily: baseFont }}>
//               eMedha Chatbot Services
//             </p>
//             <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: theme.mutedForeground, fontFamily: "monospace" }}>WABA ID: 109*********</p>
//           </div>
//         </div>
//       </div>

//       {/* Table Container */}
//       <div style={{ backgroundColor: theme.card, borderRadius: "12px", border: `1px solid ${theme.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>
//         <div style={{ padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, backgroundColor: "rgba(243, 244, 246, 0.3)", display: "flex", alignItems: "center", gap: "8px" }}>
//           <Wifi size={14} style={{ color: theme.primary }} />
//           <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: theme.foreground, fontFamily: baseFont }}>
//             Connected Phone Numbers
//           </p>
//         </div>

//         <div style={{ overflowX: "auto" }}>
//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <thead>
//               <tr>
//                 {["Display Name", "Phone Number", "Phone Number ID", "Connection", "Status", "Subscription"].map((h) => (
//                   <th key={h} style={headerStyle}>{h}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {numbers.map((n, i) => (
//                 <tr key={i}>
//                   <td style={{ ...cellStyle, fontWeight: "600" }}>{n.displayName}</td>
//                   <td style={{ ...cellStyle, fontFamily: "monospace" }}>{n.phone}</td>
//                   <td style={{ ...cellStyle, fontFamily: "monospace", color: theme.mutedForeground }}>{n.phoneId}</td>
//                   <td style={cellStyle}>{n.connection}</td>
//                   <td style={cellStyle}>
//                     <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "2px 8px", borderRadius: "12px", fontSize: "11px", fontWeight: "600", backgroundColor: theme.emeraldBg, color: theme.emeraldText, border: `1px solid ${theme.emeraldBorder}` }}>
//                       <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: theme.emeraldDot, display: "inline-block" }} />
//                       {n.status}
//                     </span>
//                   </td>
//                   <td style={cellStyle}>
//                     <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "12px", fontSize: "11px", fontWeight: "500", backgroundColor: theme.muted, color: theme.primary, border: `1px solid ${theme.border}` }}>
//                       {n.subscription}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── My Account Page ──────────────────────────────────────────────────────────

// export default function MyAccount({ navigate }) {
//   const [tab, setTab] = useState("account");

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: theme.background, minHeight: "100vh", fontFamily: baseFont, boxSizing: "border-box" }}>
//       {/* Header */}
//       <div style={{ padding: "20px 24px 0 24px", display: "flex", alignItems: "center", gap: "12px" }}>
//         <button
//           onClick={() => navigate?.("Dashboard")}
//           style={{ width: "32px", height: "32px", borderRadius: "8px", border: `1px solid ${theme.border}`, display: "flex", alignItems: "center", justifyContent: "center", color: theme.mutedForeground, backgroundColor: "#ffffff", cursor: "pointer", flexShrink: 0 }}
//         >
//           <ArrowLeft size={15} />
//         </button>
//         <div>
//           <h1 style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: theme.foreground, lineHeight: "1", fontFamily: baseFont }}>
//             My Account
//           </h1>
//           <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: theme.mutedForeground }}>Manage your account details and connected numbers</p>
//         </div>
//       </div>

//       {/* Tab Switcher */}
//       <div style={{ padding: "16px 24px 20px 24px" }}>
//         <div style={{ display: "flex", gap: "4px", padding: "4px", backgroundColor: theme.muted, borderRadius: "12px", width: "fit-content" }}>
//           {[
//             { key: "account", label: "My Account", icon: <User size={13} /> },
//             { key: "whatsapp", label: "WhatsApp Numbers", icon: <Phone size={13} /> },
//           ].map(({ key, label, icon }) => {
//             const isActive = tab === key;
//             return (
//               <button
//                 key={key}
//                 onClick={() => setTab(key)}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "8px 16px",
//                   borderRadius: "8px",
//                   fontSize: "12px",
//                   fontWeight: "600",
//                   cursor: "pointer",
//                   border: isActive ? `1px solid ${theme.border}` : "1px solid transparent",
//                   backgroundColor: isActive ? theme.card : "transparent",
//                   color: isActive ? theme.primary : theme.mutedForeground,
//                   boxShadow: isActive ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
//                   transition: "all 0.2s ease",
//                   fontFamily: baseFont,
//                 }}
//               >
//                 {icon} {label}
//                 {isActive && <ChevronRight size={11} style={{ color: "rgba(37, 99, 235, 0.6)" }} />}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Tab Content Area */}
//       <div style={{ padding: "0 24px 40px 24px" }}>
//         {tab === "account" && <AccountTab />}
//         {tab === "whatsapp" && <WhatsAppTab />}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
import SubscriptionPopup from './SubscriptionPopup';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { FaBriefcase, FaCog, FaLock, FaUser, FaWhatsapp } from 'react-icons/fa';

// ─── Unified Premium Styling Theme Constants ─────────────────────────────────
const theme = {
  primary: "#2563eb",
  primaryForeground: "#ffffff",
  primaryLight: "rgba(37, 99, 235, 0.1)",
  primaryFocus: "rgba(37, 99, 235, 0.3)",
  background: "#f9fafb",
  card: "#ffffff",
  border: "#e5e7eb",
  muted: "#f3f4f6",
  mutedForeground: "#6b7280",
  foreground: "#111827",
  inputBackground: "#ffffff",
  destructive: "#ef4444",
  blueBg: "#eff6ff",
  blueBorder: "#bfdbfe",
  blueText: "#1d4ed8",
  emeraldBg: "#ecfdf5",
  emeraldBorder: "#a7f3d0",
  emeraldText: "#047857",
  emeraldDot: "#10b981",
  yellowBg: "#fefce8",
  yellowBorder: "#fef08a",
  yellowText: "#a16207"
};

const baseFont = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

const AccountDetails = () => {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    whatsappBusinessId: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [image, setImage] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setFormData({
        name: storedUser.name || '',
        email: storedUser.email || '',
        phone: storedUser.phone || '',
        whatsappBusinessId: storedUser.whatsappBusinessId || '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmNewPassword) {
      alert('New passwords do not match.');
      return;
    }

    const form = new FormData();
    form.append('userId', user.id);
    form.append('name', formData.name);
    form.append('email', formData.email);
    form.append('phone', formData.phone);
    form.append('whatsappBusinessId', formData.whatsappBusinessId);
    form.append('oldPassword', formData.oldPassword);
    form.append('newPassword', formData.newPassword);
    if (image) form.append('image', image);

    try {
      const response = await fetch('https://botapi.emedha.in/auth/api/update-profile', {
        method: 'PUT',
        body: form,
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.error || 'Error updating profile');
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error during profile update:', error);
      alert('Error during profile update. Please try again later.');
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const [selectedSection, setSelectedSection] = useState('account');
  const handleSectionChange = (section) => {
    setSelectedSection(section);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'DISPLAY NAME',
        accessor: 'displayName',
      },
      {
        Header: 'PHONE NUMBER',
        accessor: 'phoneNumber',
      },
      {
        Header: 'PHONE NUMBER ID',
        accessor: 'phoneNumberId',
      },
      {
        Header: 'CONNECTION',
        accessor: 'connection',
      },
      {
        Header: 'STATUS',
        accessor: 'status',
        Cell: ({ value }) => (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', backgroundColor: value === 'CONNECTED' ? theme.emeraldBg : theme.muted, color: value === 'CONNECTED' ? theme.emeraldText : theme.mutedForeground, border: `1px solid ${value === 'CONNECTED' ? theme.emeraldBorder : theme.border}` }}>
            {value === 'CONNECTED' && <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: theme.emeraldDot, display: 'inline-block' }} />}
            {value}
          </span>
        ),
      },
      {
        Header: 'SUBSCRIPTION',
        accessor: 'subscription',
        Cell: ({ value }) => (
          <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500', backgroundColor: theme.muted, color: theme.primary, border: `1px solid ${theme.border}` }}>
            {value}
          </span>
        ),
      },
    ],
    []
  );

  const data = React.useMemo(
    () => [
      {
        displayName: 'eMedha Chatbot Services Test',
        phoneNumber: '+91 83297 69248',
        phoneNumberId: '110********',
        connection: 'Direct',
        status: 'CONNECTED',
        subscription: 'Startup (Monthly)',
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  // Reusable inline styled local fields to match specified identity
  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.inputBackground,
    fontSize: '14px',
    color: theme.foreground,
    outline: 'none',
    boxSizing: 'border-box',
    marginTop: '6px',
    transition: 'all 0.2s ease',
  };

  const labelStyle = {
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    color: theme.foreground,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontFamily: baseFont,
  };

  const cellStyle = {
    padding: '16px 20px',
    fontSize: '13px',
    color: theme.foreground,
    borderBottom: `1px solid ${theme.border}`,
    textAlign: 'left'
  };

  const headerStyle = {
    padding: '12px 20px',
    fontSize: '11px',
    fontWeight: '600',
    color: theme.mutedForeground,
    textTransform: 'uppercase',
    backgroundColor: 'rgba(243, 244, 246, 0.4)',
    borderBottom: `1px solid ${theme.border}`,
    textAlign: 'left',
    fontFamily: baseFont
  };

  return (
    <div style={{ flex: 1, overflowY: 'auto', backgroundColor: theme.background, minHeight: '100vh', fontFamily: baseFont, boxSizing: 'border-box'}}>
      
      {/* Header Info Block */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '800', color: theme.foreground, fontFamily: baseFont }}>My Account Profile</h1>
        <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: theme.mutedForeground }}>Manage your global account details, operational settings and secure access tokens.</p>
      </div>

      {/* Segment switcher */}
      <div style={{ display: 'flex', gap: '6px', padding: '4px', backgroundColor: theme.muted, borderRadius: '12px', width: 'fit-content', marginBottom: '24px' }}>
        <button
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer',
            border: selectedSection === 'account' ? `1px solid ${theme.border}` : '1px solid transparent',
            backgroundColor: selectedSection === 'account' ? theme.card : 'transparent',
            color: selectedSection === 'account' ? theme.primary : theme.mutedForeground,
            boxShadow: selectedSection === 'account' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
            transition: 'all 0.2s ease',
            fontFamily: baseFont,
          }}
          onClick={() => handleSectionChange('account')}>
          <FaUser size={13} /> My Account
        </button>
        <button
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer',
            border: selectedSection === 'whatsapp' ? `1px solid ${theme.border}` : '1px solid transparent',
            backgroundColor: selectedSection === 'whatsapp' ? theme.card : 'transparent',
            color: selectedSection === 'whatsapp' ? theme.primary : theme.mutedForeground,
            boxShadow: selectedSection === 'whatsapp' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
            transition: 'all 0.2s ease',
            fontFamily: baseFont,
          }}
          onClick={() => handleSectionChange('whatsapp')}>
          <FaWhatsapp size={13} /> WhatsApp Numbers
        </button>
        {/* <button
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: 'pointer',
            border: selectedSection === 'subscriptions' ? `1px solid ${theme.border}` : '1px solid transparent',
            backgroundColor: selectedSection === 'subscriptions' ? theme.card : 'transparent',
            color: selectedSection === 'subscriptions' ? theme.primary : theme.mutedForeground,
            boxShadow: selectedSection === 'subscriptions' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
            transition: 'all 0.2s ease',
            fontFamily: baseFont,
          }}
          onClick={() => handleSectionChange('subscriptions')}>
          <FaCog size={13} /> My Subscriptions
        </button> */}
      </div>

      {/* Account Details Content Wrapper */}
      {selectedSection === 'account' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* Informational Notification Banner */}
          <div style={{ backgroundColor: theme.blueBg, border: `1px solid ${theme.blueBorder}`, borderRadius: '12px', padding: '12px 16px', display: 'flex', alignItems: 'start', gap: '12px' }}>
            <FaUser style={{ color: theme.blueText, marginTop: '3px', flexShrink: 0 }} size={14} />
            <p style={{ margin: 0, fontSize: '12px', color: theme.blueText, lineHeight: '1.5', fontFamily: baseFont }}>
              Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts. 
              To edit how your WhatsApp profile looks to your contacts, you can edit that from <a href="#" style={{ color: theme.primary, fontWeight: '600', textDecoration: 'none' }}>Settings page</a>.
            </p>
          </div>

          <form onSubmit={handleSaveChanges} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            
            {/* Box Section: Account Details */}
            <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 20px', borderBottom: `1px solid ${theme.border}`, backgroundColor: 'rgba(243, 244, 246, 0.3)' }}>
                <FaUser style={{ color: theme.primary }} />
                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: theme.foreground, fontFamily: baseFont }}>Account Information</h3>
              </div>
              <div style={{ padding: '20px' }}>
                <p style={{ margin: '0 0 20px 0', fontSize: '12px', color: theme.mutedForeground }}>
                  Details you enter on this page are for internal use like billing, support, etc. and won't be seen by your contacts.
                </p>

                {/* Profile Image Row Layout */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', borderBottom: `1px solid ${theme.border}`, paddingBottom: '20px' }}>
                  <div style={{ width: '56px', height: '56px', borderRadius: '50%', backgroundColor: theme.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0, border: `2px solid ${theme.border}` }}>
                    {avatarPreview ? (
                      <img src={avatarPreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <FaUser size={22} style={{ color: theme.primary }} />
                    )}
                  </div>
                  <div>
                    <label style={{ ...labelStyle, marginBottom: '4px' }}>Profile Image</label>
                    <input 
                      type="file" 
                      name="image" 
                      accept="image/*" 
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setImage(file);
                        if(file) {
                          const reader = new FileReader();
                          reader.onload = (ev) => setAvatarPreview(ev.target.result);
                          reader.readAsDataURL(file);
                        }
                      }} 
                      style={{ fontSize: '12px', color: theme.mutedForeground }}
                    />
                  </div>
                </div>

                {/* Account Grid fields */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
                  <div>
                    <label style={labelStyle}>Name *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} style={inputStyle} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Email Address *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Mobile *</label>
                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} required />
                  </div>
                  <div>
                    <label style={labelStyle}>Timezone *</label>
                    <select name="timezone" value={formData.timezone || 'UTC+5:30'} onChange={handleChange} style={inputStyle}>
                      <option value="UTC+5:30">UTC+5:30 — India Standard Time</option>
                    </select>
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={labelStyle}>WhatsApp Business ID *</label>
                    <input type="text" name="whatsappBusinessId" value={formData.whatsappBusinessId} onChange={handleChange} style={inputStyle} required />
                  </div>
                </div>
              </div>
            </div>

            {/* Box Section: Billing Info */}
            <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 20px', borderBottom: `1px solid ${theme.border}`, backgroundColor: 'rgba(243, 244, 246, 0.3)' }}>
                <FaBriefcase style={{ color: theme.primary }} />
                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: theme.foreground, fontFamily: baseFont }}>Billing Details</h3>
              </div>
              <div style={{ padding: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
                  <div>
                    <label style={labelStyle}>First Name *</label>
                    <input type="text" name="billingFirstName" value={formData.billingFirstName || ''} onChange={handleChange} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Last Name *</label>
                    <input type="text" name="billingLastName" value={formData.billingLastName || ''} onChange={handleChange} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Company Name (Optional)</label>
                    <input type="text" name="companyName" value={formData.companyName || ''} onChange={handleChange} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Country / Region</label>
                    <input type="text" name="country" value={formData.country || ''} onChange={handleChange} style={inputStyle} />
                  </div>
                </div>
              </div>
            </div>

            {/* Box Section: Cryptographic Security Management */}
            <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 20px', borderBottom: `1px solid ${theme.border}`, backgroundColor: 'rgba(243, 244, 246, 0.3)' }}>
                <FaLock style={{ color: theme.primary }} />
                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: theme.foreground, fontFamily: baseFont }}>Password</h3>
              </div>
              <div style={{ padding: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px' }}>
                  <div>
                    <label style={labelStyle}>Current Password *</label>
                    <input type="password" name="oldPassword" value={formData.oldPassword} onChange={handleChange} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>New Password *</label>
                    <input type="password" name="newPassword" value={formData.newPassword} onChange={handleChange} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Confirm New Password *</label>
                    <input type="password" name="confirmNewPassword" value={formData.confirmNewPassword || ''} onChange={handleChange} style={inputStyle} />
                  </div>
                </div>
              </div>
            </div>

            {/* Form Operation Execution Controller */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="submit" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '8px', backgroundColor: theme.primary, color: theme.primaryForeground, border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)', fontFamily: baseFont }}>
                Save Changes
              </button>
            </div>

          </form>
        </div>
      )}

      {/* WhatsApp Numbers Layout Block Component Rendering section */}
      {selectedSection === 'whatsapp' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: '12px', padding: '12px 16px', display: 'flex', alignItems: 'start', gap: '12px' }}>
            <FaWhatsapp size={15} style={{ color: theme.primary, marginTop: '2px', flexShrink: 0 }} />
            <p style={{ margin: 0, fontSize: '12px', color: theme.foreground, lineHeight: '1.5', fontFamily: baseFont }}>
              On this page you'll find all the WhatsApp phone numbers that are connected with <span style={{ fontWeight: '600' }}>eMedha Chatbot Services</span> and the WhatsApp Cloud APIs.
            </p>
          </div>

          {/* WABA Metadata Wrapper Card */}
          <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'between', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '10px', backgroundColor: theme.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ color: '#ffffff', fontSize: '12px', fontWeight: '700' }}>eM</span>
                </div>
                <div>
                  <p style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: theme.foreground, fontFamily: baseFont }}>eMedha Chatbot Services</p>
                  <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: theme.mutedForeground, fontFamily: 'monospace' }}>
                    WABA ID: 109<span style={{ backgroundColor: theme.muted, borderRadius: '4px', padding: '2px 6px', marginLeft: '4px' }}>********</span>
                  </p>
                </div>
              </div>
              <button style={{ height: '38px', padding: '0 16px', border: `1px solid ${theme.border}`, backgroundColor: '#ffffff', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: theme.foreground, fontFamily: baseFont }}>
                WhatsApp Manager
              </button>
            </div>
          </div>

          {/* Connected Grid Data Representation Table view */}
          <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table {...getTableProps()} style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th {...column.getHeaderProps()} style={headerStyle}>
                          {column.render('Header')}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map(row => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} style={{ borderBottom: `1px solid ${theme.border}` }}>
                        {row.cells.map(cell => {
                          return (
                            <td {...cell.getCellProps()} style={cellStyle}>
                              {cell.render('Cell')}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      )}

      {/* Subscription Section Implementation Block */}
      {selectedSection === 'subscriptions' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${theme.border}`, paddingBottom: '14px' }}>
            <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: theme.foreground, fontFamily: baseFont }}>My Subscriptions</h2>
            <button 
              onClick={() => setShowPopup(true)} 
              style={{ padding: '8px 16px', borderRadius: '8px', backgroundColor: theme.primary, color: theme.primaryForeground, border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: baseFont }}
            >
              Buy Subscription
            </button>
          </div>

          {/* Subscriptions Ledger Data Table mapping */}
          <div style={{ backgroundColor: theme.card, borderRadius: '12px', border: `1px solid ${theme.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {["ID", "STATUS", "SUBSCRIPTION", "NEXT PAYMENT", "TOTAL", "ASSOCIATED WHATSAPP NUMBER", ""].map((h) => (
                      <th key={h} style={headerStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    { id: "#235171", status: "CANCELLED", type: "eMedha Chatbot Services - Startup (Monthly)", next: "-", total: "₹2,358.82", assoc: "-" },
                    { id: "#232409", status: "CANCELLED", type: "eMedha Chatbot Services - Startup (Monthly)", next: "-", total: "₹2,358.82", assoc: "-" },
                    { id: "#158351", status: "CANCELLED", type: "eMedha Chatbot Services - Startup (Monthly)", next: "-", total: "₹23.59", assoc: "-" },
                    { id: "#56217", status: "PENDING CANCELLATION", type: "eMedha Chatbot Services - Startup (Monthly)", next: "-", total: "₹23.59", assoc: "eMedha Chatbot Services Test (+91 83297 69248)" }
                  ].map((sub, idx) => (
                    <tr key={idx} style={{ borderBottom: `1px solid ${theme.border}` }}>
                      <td style={{ ...cellStyle, color: theme.primary, fontWeight: '600' }}>{sub.id}</td>
                      <td style={cellStyle}>
                        <span style={{ 
                          display: 'inline-flex', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600',
                          backgroundColor: sub.status === 'CANCELLED' ? theme.muted : theme.yellowBg, 
                          color: sub.status === 'CANCELLED' ? theme.mutedForeground : theme.yellowText,
                          border: `1px solid ${sub.status === 'CANCELLED' ? theme.border : theme.yellowBorder}`
                        }}>
                          {sub.status}
                        </span>
                      </td>
                      <td style={cellStyle}>{sub.type}</td>
                      <td style={cellStyle}>{sub.next}</td>
                      <td style={cellStyle}>{sub.total}</td>
                      <td style={{ ...cellStyle, color: sub.assoc !== '-' ? theme.primary : theme.foreground }}>{sub.assoc}</td>
                      <td style={{ ...cellStyle, textAlign: 'right' }}>
                        <button style={{ padding: '4px 12px', borderRadius: '6px', border: `1px solid ${theme.primary}`, backgroundColor: 'transparent', color: theme.primary, fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Popup
            open={showPopup}
            closeOnDocumentClick
            onClose={() => setShowPopup(false)}
            modal
            nested
          >
            {(close) => (
              <div style={{ position: 'relative', background: '#fff', borderRadius: '12px', overflow: 'hidden' }}>
                <SubscriptionPopup onClose={close} />
              </div>
            )}
          </Popup>
        </div>
      )}

    </div>
  );
};

export default AccountDetails;


// import React, { useEffect, useState } from 'react';

// const AccountDetails = () => {
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     whatsappBusinessId: '',
//     oldPassword: '',
//     newPassword: '',
//     confirmPassword: '',
//   });

//   useEffect(() => {
//     // Simulating getting user data from sessionStorage (or another state management system)
//     const storedUser = JSON.parse(sessionStorage.getItem('user'));
//     if (storedUser) {
//       setUser(storedUser);
//       setFormData({
//         name: storedUser.name || '',
//         email: storedUser.email || '',
//         phone: storedUser.phone || '',
//         whatsappBusinessId: storedUser.whatsappBusinessId || '',
//         oldPassword: '',
//         newPassword: '',
//         confirmPassword: '',
//       });
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSaveChanges = async (e) => {
//     e.preventDefault();

//     // Check if form data is correct
//     console.log('Form data:', formData);

//     try {
//         const response = await fetch('https://botapi.emedha.in/auth/api/update-profile', {
//             method: 'PUT',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 userId: user.id,
//                 name: formData.name,
//                 email: formData.email,
//                 phone: formData.phone,
//                 whatsappBusinessId: formData.whatsappBusinessId,
//                 oldPassword: formData.oldPassword,
//                 newPassword: formData.newPassword,
//             }),
//         });

//         const data = await response.json();
//         if (!response.ok) {
//             alert(data.error || 'Error updating profile');
//         } else {
//             alert(data.message);  // Success message
//         }
//     } catch (error) {
//         console.error('Error during profile update:', error);
//         alert('Error during profile update. Please try again later.');
//     }
// };


//   if (!user) {
//     return <div>Loading...</div>; // Loading state while user data is being fetched
//   }

//   return (
//     <div>
//       <h2>Account Details</h2>
//       <form onSubmit={handleSaveChanges}>
//         <label>
//           Name:
//           <input type="text" name="name" value={formData.name} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Email:
//           <input type="email" name="email" value={formData.email} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Phone:
//           <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           WhatsApp Business ID:
//           <input type="text" name="whatsappBusinessId" value={formData.whatsappBusinessId} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Old Password:
//           <input type="password" name="oldPassword" value={formData.oldPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           New Password:
//           <input type="password" name="newPassword" value={formData.newPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <label>
//           Confirm New Password:
//           <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
//         </label>
//         <br />
//         <button type="submit">Save Changes</button>
//       </form>
//     </div>
//   );
// };

// export default AccountDetails;
